import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const SECTIONS = [
  {
    title: 'Collecte des données',
    content: `Nous collectons les données personnelles que vous nous fournissez volontairement lors de votre utilisation du site, notamment lors de la passation d'une commande ou de la prise de contact via notre formulaire. Ces données incluent votre nom, prénom, adresse email et numéro de téléphone.`,
  },
  {
    title: 'Utilisation des données',
    content: `Les données collectées sont utilisées exclusivement dans le cadre de la gestion de votre relation avec Four a Tacos : traitement des commandes, envoi de confirmations, amélioration de nos services et communication commerciale si vous y avez consenti. Vos données ne sont jamais revendues à des tiers.`,
  },
  {
    title: 'Durée de conservation',
    content: `Vos données sont conservées pendant une durée de 3 ans à compter de votre dernière commande, conformément aux obligations légales comptables.`,
  },
  {
    title: 'Outils tiers',
    content: `Notre site utilise Firebase de Google pour le stockage des données (politique de confidentialité : firebase.google.com).`,
  },
  {
    title: 'Cookies',
    content: `Notre site utilise des cookies pour améliorer votre expérience de navigation, analyser le trafic et personnaliser le contenu. Vous pouvez à tout moment désactiver les cookies dans les paramètres de votre navigateur. Le refus des cookies peut limiter certaines fonctionnalités du site.`,
  },
  {
    title: 'Vos droits',
    content: `Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Vous pouvez également vous opposer à leur traitement ou en demander la limitation. Ces droits s'exercent en nous contactant directement.\n\nVous disposez également du droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr).`,
  },
  {
    title: 'Contact',
    content: `Responsable du traitement : Muhamed Ali Yilmaz — MY RESTO SARL\n\nPour toute question relative à la protection de vos données personnelles ou pour exercer vos droits, vous pouvez nous contacter à l'adresse suivante : contact@fouratacos.com — Four a Tacos, 303 Rue de la République, 73000 Chambéry.`,
  },
];

export default function PolitiqueConfidentialite() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Politique de Confidentialité — Four A Tacos';
  }, []);

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main className="legal-main" style={{ flex: 1 }}>
        <h1 className="legal-title" style={{ marginBottom: '48px' }}>
          POLITIQUE DE CONFIDENTIALITÉ
        </h1>

        {SECTIONS.map(({ title, content }) => (
          <section key={title} style={{ marginBottom: '40px' }}>
            <h2 style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '18px', fontWeight: '700', color: '#C10230', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>
              {title}
            </h2>
            <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '15px', color: '#4A4A4A', lineHeight: '1.8', margin: 0, whiteSpace: 'pre-line' }}>
              {content}
            </p>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
